import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { ProductsPlaceHolder } from './ProductsPlaceHolder'
import { enablePlpRedesign } from 'src/utils'
import { isMerchPLP } from 'config/appConfig/globalProps'
import './styles.scss'

function LoadingProducts() {
  let products = Array(8).fill('product')
  let listItems = Array(6).fill('listItem')
  let listBlocks = Array(3).fill('list')

  // Set different placeholder counts for mobile view
  if (
    typeof window !== 'undefined' &&
    window.innerWidth < 567 &&
    enablePlpRedesign()
  ) {
    products = Array(2).fill('product')
    listItems = Array(2).fill('listItem')
    listBlocks = Array(1).fill('list')
  }
  // Default (non-redesign) placeholder
  return (
    <Container className="plp-page placholder-custom">
      <Row className="bg-white p-0 plp-placeholder-row mt-3">
        <Col md={3} className="d-none d-md-inline sidebar-isLoading">
          {listBlocks.length > 0 &&
            listBlocks.map((list, i) => (
              <div className="listBlock" key={i}>
                <div className="d-flex justify-content-between mt-3 mb-3">
                  <p className="w-40"></p>
                  <p className="w-25"></p>
                </div>
                <p className="w-50"></p>
                <ul>
                  {listItems.length > 0 &&
                    listItems.map((listItem, i) => (
                      <li className="my-2" key={i}></li>
                    ))}
                </ul>
                <p className="w-40 m-0"></p>
              </div>
            ))}
        </Col>
        <Col md={9} className="product-isloading p-0">
          <Col xs={12}>
            <Row className="right-top-row">
              <Col
                xs={4}
                md={2}
                className="d-flex align-items-center justify-content-center search-result">
                <p className="w-100"></p>
              </Col>
              <Col
                xs={{ span: 4, offset: 4 }}
                md={{ span: 4, offset: 6 }}
                className="d-flex sort-column">
                <p className="w-25 d-none d-md-inline sort-label"></p>
                <p className="ml-3 w-inherit p-4"></p>
              </Col>
            </Row>
            <div>
              <ProductsPlaceHolder
                containerClsName={`row d-flex flex-wrap right-below-row ${enablePlpRedesign() ? 'flex-column flex-md-row' : ''}`}
                products={products}
              />
            </div>
          </Col>
        </Col>
      </Row>
    </Container>
  )
}

export { LoadingProducts }
export default LoadingProducts
